<script setup lang="ts">
import { localize } from "@/utils";
</script>

<template>
  <div id="ct" class="flex-layout-body">
    <div class="grid">
      <div class="grid-side">
        <router-link to="../membership" class="btn-back"
          ><i class="icon icon-back">{{ localize("뒤로") }}</i></router-link
        >
        <h2 class="fs-1">Member<br />Information</h2>
        <u class="text-muted">Anything else?</u>
        <img src="@/assets/playground/img/membership.png" alt="" />
      </div>
      <div class="grid-content">
        <div class="row h-100">
          <div class="col-6">
            <section class="box box-shadow flex-column">
              <h3 class="fs-3 pb-3 mb-4 font-poppins">Player</h3>
              <div class="toggle-fieldset">
                <div class="flex-center">
                  <h4 class="cell-title">{{ localize("공지") }}</h4>
                  <div class="row no-gutters">
                    <div class="col">{{ localize("웹") }}</div>
                    <div class="col">{{ localize("메일") }}</div>
                    <div class="col">{{ localize("플레이그라운드") }}</div>
                  </div>
                </div>
                <div class="flex-center">
                  <h5 class="fs-sm cell-title">{{ localize("R2 시스템 공지") }}</h5>
                  <div class="row no-gutters">
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                  </div>
                </div>
                <div class="flex-center">
                  <h5 class="fs-sm cell-title">{{ localize("개인 공지사항") }}</h5>
                  <div class="row no-gutters">
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                  </div>
                </div>
              </div>
              <div class="toggle-fieldset">
                <div class="flex-center">
                  <h4 class="cell-title">{{ localize("택 정보") }}</h4>
                  <div class="row no-gutters">
                    <div class="col">{{ localize("웹") }}</div>
                    <div class="col">{{ localize("메일") }}</div>
                    <div class="col">{{ localize("플레이그라운드") }}</div>
                  </div>
                </div>
                <div class="flex-center">
                  <h5 class="fs-sm cell-title">{{ localize("이벤트 및 혜택 정보") }}</h5>
                  <div class="row no-gutters">
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                  </div>
                </div>
              </div>
              <div class="toggle-fieldset">
                <div class="flex-center">
                  <h4 class="cell-title">{{ localize("주문") }}</h4>
                  <div class="row no-gutters">
                    <div class="col">{{ localize("웹") }}</div>
                    <div class="col">{{ localize("메일") }}</div>
                    <div class="col">{{ localize("플레이그라운드") }}</div>
                  </div>
                </div>
                <div class="flex-center">
                  <h5 class="fs-sm cell-title">{{ localize("주요 상태 변경 외") }}</h5>
                  <div class="row no-gutters">
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="col-6">
            <section v-if="true" class="box box-shadow flex-column">
              <h3 class="fs-3 pb-3 mb-4 font-poppins">Planner, R2 Center</h3>
              <div class="empty">
                <p>{{ localize("아직 등록된 정보가 없습니다.") }}</p>
                <div class="btn-wrap">
                  <a class="btn btn-lg">Register</a>
                </div>
              </div>
            </section>

            <section v-else class="box box-shadow flex-column">
              <h3 class="fs-3 pb-3 mb-4 font-poppins">Planner, R2 Center</h3>
              <div class="toggle-fieldset">
                <div class="flex-center">
                  <h4 class="cell-title">{{ localize("공지") }}</h4>
                  <div class="row no-gutters">
                    <div class="col">{{ localize("웹") }}</div>
                    <div class="col">{{ localize("메일") }}</div>
                    <div class="col">{{ localize("플레이그라운드") }}</div>
                  </div>
                </div>
                <div class="flex-center">
                  <h5 class="fs-sm cell-title">{{ localize("R2 시스템 공지") }}</h5>
                  <div class="row no-gutters">
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                  </div>
                </div>
                <div class="flex-center">
                  <h5 class="fs-sm cell-title">{{ localize("개인 공지사항") }}</h5>
                  <div class="row no-gutters">
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                  </div>
                </div>
              </div>
              <div class="toggle-fieldset">
                <div class="flex-center">
                  <h4 class="cell-title">{{ localize("택 정보") }}</h4>
                  <div class="row no-gutters">
                    <div class="col">{{ localize("웹") }}</div>
                    <div class="col">{{ localize("메일") }}</div>
                    <div class="col">{{ localize("플레이그라운드") }}</div>
                  </div>
                </div>
                <div class="flex-center">
                  <h5 class="fs-sm cell-title">{{ localize("이벤트 및 혜택 정보") }}</h5>
                  <div class="row no-gutters">
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                  </div>
                </div>
              </div>
              <div class="toggle-fieldset">
                <div class="flex-center">
                  <h4 class="cell-title">{{ localize("주문") }}</h4>
                  <div class="row no-gutters">
                    <div class="col">{{ localize("웹") }}</div>
                    <div class="col">{{ localize("메일") }}</div>
                    <div class="col">{{ localize("플레이그라운드") }}</div>
                  </div>
                </div>
                <div class="flex-center">
                  <h5 class="fs-sm cell-title">{{ localize("주요 상태 변경 외") }}</h5>
                  <div class="row no-gutters">
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                    <div class="col"><input class="form-switch-input" type="checkbox" /></div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
